import { SVGProps, useEffect, useState } from 'react'

import { EyeClosedIcon, EyeOpenIcon } from 'app/common/presentation/icons'

import styles from './Input.module.scss'

export interface InputProps
  extends Pick<
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'autoComplete' | 'autoFocus' | 'className' | 'placeholder' | 'type' | 'value'
  > {
  error?: string
  iconLeft?: React.FC<SVGProps<SVGSVGElement>>
  iconRight?: React.FC<SVGProps<SVGSVGElement>>
  label?: string
  mandatory?: boolean
  onChange?: (value: string) => void
  small?: boolean
  value: string
}

const Input = ({
  className,
  error,
  iconLeft: IconLeft,
  iconRight: IconRight,
  label,
  mandatory,
  onChange,
  small = false,
  type: incomingType,
  ...inputProps
}: InputProps) => {
  const [usedType, setUsedType] = useState(incomingType)

  useEffect(() => {
    setUsedType(incomingType)
  }, [incomingType])

  return (
    <div
      className={`${styles.container} ${small ? styles.small : ''} ${className ?? ''}`}
      data-testid="input-container"
    >
      {label && (
        <label className={styles.label} data-testid="label">
          {`${label}${mandatory ? ' *' : ''}`}
        </label>
      )}

      <div className={[styles.inputContainer, error ? styles.error : undefined].join(' ')}>
        {IconLeft && <IconLeft />}
        <input
          className={styles.input}
          disabled={!onChange}
          onChange={onChange ? (e) => onChange(e.target.value) : undefined}
          type={usedType}
          {...inputProps}
          data-testid="input"
        />
        {IconRight && <IconRight />}
        {incomingType === 'password' &&
          (usedType === 'password' ? (
            <EyeClosedIcon onClick={() => setUsedType('text')} />
          ) : (
            <EyeOpenIcon onClick={() => setUsedType('password')} />
          ))}
      </div>

      {error && (
        <div className={styles.error} data-testid="error">
          {error}
        </div>
      )}
    </div>
  )
}

export default Input
